import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationUserDto } from "@entities/commonTypes";

export interface ProfileState {
  profile: ApplicationUserDto | null;
}

const initialState: ProfileState = {
  profile: null,
};

export const PROFILE_SLICE_KEY = "profile";

export const profileSlice = createSlice({
  name: PROFILE_SLICE_KEY,
  initialState,
  reducers: {
    setProfile: (state, action: PayloadAction<ApplicationUserDto>) => {
      state.profile = action.payload;
    },
    clearProfile: (state) => {
      state.profile = null;
    },
  },
});

export const { setProfile, clearProfile } = profileSlice.actions;
